import Aboutus from "../components/Aboutus";
import Team from "../components/Team";
import Testimonial from "../components/Testimonial";


import React from 'react';

function About(props) {
  return (
    <>
      <Aboutus></Aboutus>
      <Team></Team>
      <Testimonial></Testimonial>
    </>
  );
}

export default About;